<template>
  <tile class="opc-zsched">
    <foldable v-model="isExpanded" :title="title" :isRemoveWrapAriaLabelledby="true">
      <div slot="head" class="opc-zm-base-card__head">
        <div class="opc-zm-base-card__head-left">
          <img class="opc-zm-base-card__logo" :src="logo" :alt="title" />
        </div>
        <div class="opc-zm-base-card__head-right">
          <h2 class="opc-zm-base-card__name text-capitalize">
            {{ title }}
            <i class="zm-icon-success main-icon" aria-hidden="true"></i>
          </h2>
          <div class="opc-zm-base-card__view-detail-button">
            <zm-button
              data-testid="checkout-button-250"
              class="opc-zm-base-card__link"
              type="link"
              @click="handlePlanDetailsClick"
              v-if="isExpanded && showPlanDetail"
            >
              {{ $t('billing.plan_details') }}
            </zm-button>
          </div>
          <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
            {{
              $t('billing.zone.desc1', [
                form.selectedNumber,
                $money(formPlan ? formPlan.amount : 0),
                $t('billing.trial.unit_suffix', [$t(`billing.common.per_billing_cycle_user.${form.billingCycle}`)]),
              ])
            }}
          </div>
        </div>
      </div>
      <div class="opc-zsched__trial-desc">
        <p class="opc-zsched__desc-text">
          <img src="@/assets/plans/checked_checkboxes-green.svg" alt="Include" />
          {{ $t('billing.scheduler.free_trial_descriptions.duration', [trialDays]) }}
        </p>
        <p class="opc-zsched__desc-text">
          <img src="@/assets/plans/checked_checkboxes-green.svg" alt="" />
          {{ $t('billing.scheduler.free_trial_descriptions.sharelink') }}
        </p>
        <p class="opc-zsched__desc-text">
          <img src="@/assets/plans/checked_checkboxes-green.svg" alt="" />
          {{ $t('billing.scheduler.free_trial_descriptions.customizable') }}
        </p>
        <p class="opc-zsched__desc-text">
          <img src="@/assets/plans/checked_checkboxes-green.svg" alt="" />
          {{ $t('billing.scheduler.free_trial_descriptions.cancel') }}
        </p>
      </div>
      <div class="opc-zsched__main">
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form">
          <zm-form-item :label="$t('billing.select_billing_cycle')" id="opc-zsched__billing-cycle">
            <billed-billing-cycle-radio
              v-model="form.billingCycle"
              :billingCycleList="billingCycleList"
              :is-trial="true"
              @change="updateBillingCycle"
            />
          </zm-form-item>
        </zm-form>
      </div>
      <div data-testid="checkout-div-252" class="opc-zsched__free-trial-footer" v-html="$t('billing.scheduler.free_trial_footer', [paidPurchaseLink])" @click="clickBuyNow"/>
      <basic-related-tip v-if="isNetNew" />
      <div class="opc-zm-base-card__main__footer" v-if="couldBeRemovedAsAddonCard">
        <zm-button data-testid="checkout-button-253" type="link" ghost @click="removePlanByKey" :aria-label="'remove ' + title + ' plan'">{{ $t('billing.common.remove') }}</zm-button>
      </div>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import baseFormMixin from '@/plans/ZOOM_SCHEDULER/mx/base';
import formMixin from '@/plans/ZOOM_SCHEDULER/mx/index';
import saveMixins from '../../ZOOM_MEETING/save-mixins';
import { BillingCycleEnum } from '@/common/constants';
import BasicRelatedTip from '@/plans/ZOOM_SCHEDULER/components/basic-related-tip.vue';
import { $context } from '@/global-install';
import { planTypes } from '@/common/constants'
import BilledBillingCycleRadio from "@/components/service/config-billing-cycle/billed-cycle/index.vue";

export default {
  key: planTypes[planTypes.ZOOM_SCHEDULER],
  methods: {
    BillingCycleEnum() {
      return BillingCycleEnum;
    },
  },
  mixins: [baseFormMixin, formMixin, saveMixins],
  components: {
    BilledBillingCycleRadio,
    BasicRelatedTip,
    Foldable,
    Tile
  },
  computed: {
    isNetNew() {
      return $context.is.buyNow || $context.is.buyTrial || $context.is.basic2pro;
    },
  }
};
</script>

<style lang="scss">
@import '@/styles/zoom-card.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

.opc-zsched {
  .main-icon {
    color: $theme-color;
  }

  &__trial-desc {
    margin: 14px 0 0 60px;
    @include media(mobile, tablet){
      margin: 14px 30px;
    }
  }
  &__desc-text {
    display: flex;
    align-items: center;
    color: #00053d;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    margin: 4px 0;
    @include darkTextColor;
    img {
      display: inline-block;
      margin-right: 4px;
    }
  }
  &__free-trial-footer {
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    color: #666487;
    @include darkTextColor2;
    a {
      color: #0B5CFF;
    }
  }
  .opc-card-radio {
    margin-top: 8px;

    .opc-zsched__radio {
      width: 100%;
      .zm-radio__wrap {
        width: 100%;
      }
    }
  }
  .opc-card-radio &__radio {
    .zm-radio__label--inner {
      width: 100%;
      min-height: 90px;
      padding: 16px;
    }
    &-title {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 150%;
      color: #00053d;
      margin: 0;
    }
    &-price {
      font-style: normal;
      color: #00053d;
      word-break: break-word;
      &-amount {
        font-weight: 700;
        font-size: 22px;
        line-height: 150%;
      }
      &-unit {
        font-weight: 450;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
}
</style>
